import React, { useEffect, useState } from 'react';
import {
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter,
    Button, Text, Input, FormControl, FormLabel, SimpleGrid, Alert, AlertIcon, Wrap, WrapItem, List, ListItem, ListIcon,
} from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';
import { exportarRelatorioComissao } from '../../../services/api';

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

const ATALHOS = [
    { label: 'Este mês', periodo: () => { const h = new Date(); return [iso(new Date(h.getFullYear(), h.getMonth(), 1)), iso(h)]; } },
    { label: 'Mês passado', periodo: () => { const h = new Date(); return [iso(new Date(h.getFullYear(), h.getMonth() - 1, 1)), iso(new Date(h.getFullYear(), h.getMonth(), 0))]; } },
    { label: 'Este ano', periodo: () => { const h = new Date(); return [iso(new Date(h.getFullYear(), 0, 1)), iso(h)]; } },
];

// Planilha com competencias, vendas e pagamentos do periodo (#1518).
const ModalExportar = ({ isOpen, onClose, userId, vendedor }) => {
    const [de, setDe] = useState('');
    const [ate, setAte] = useState('');
    const [erro, setErro] = useState(null);
    const [baixando, setBaixando] = useState(false);

    useEffect(() => {
        if (isOpen) {
            const [a, b] = ATALHOS[0].periodo();
            setDe(a);
            setAte(b);
            setErro(null);
        }
    }, [isOpen]);

    const baixar = async () => {
        if (!de || !ate) return setErro('Informe o período.');
        if (ate < de) return setErro('O fim do período precisa ser depois do início.');
        setBaixando(true);
        setErro(null);
        const r = await exportarRelatorioComissao(userId, de, ate);
        setBaixando(false);
        if (r.erro) return setErro(r.erro);

        const url = window.URL.createObjectURL(new Blob([r.blob]));
        const link = document.createElement('a');
        link.href = url;
        link.download = r.nome || `comissoes-${de}-a-${ate}.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={baixando ? () => {} : onClose} isCentered size={{ base: 'full', sm: 'md' }}>
            <ModalOverlay backdropFilter="blur(2px)" />
            <ModalContent borderRadius={{ base: 0, sm: 'xl' }}>
                <ModalHeader pb={1}>Exportar relatório</ModalHeader>
                <ModalCloseButton isDisabled={baixando} />
                <ModalBody>
                    <Text fontSize="sm" color="gray.600" mb={3}>
                        Planilha de {vendedor?.name || 'vendedor'} com as vendas do período (pela data da venda) e os pagamentos feitos no período.
                    </Text>
                    <List spacing={1} fontSize="sm" color="gray.700" mb={4}>
                        <ListItem><ListIcon as={FaCheck} color="green.500" />Competências: apurado, pago, compensado, a pagar e fora, por mês</ListItem>
                        <ListItem><ListIcon as={FaCheck} color="green.500" />Vendas: comissão e situação de cada venda</ListItem>
                        <ListItem><ListIcon as={FaCheck} color="green.500" />Pagamentos: cada item pago ou desfeito</ListItem>
                    </List>
                    <Wrap spacing={2} mb={3}>
                        {ATALHOS.map((a) => (
                            <WrapItem key={a.label}>
                                <Button size="xs" variant="outline" onClick={() => { const [x, y] = a.periodo(); setDe(x); setAte(y); setErro(null); }}>{a.label}</Button>
                            </WrapItem>
                        ))}
                    </Wrap>
                    <SimpleGrid columns={2} spacing={3}>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm" mb={1}>De</FormLabel>
                            <Input type="date" size="sm" borderRadius="md" value={de} onChange={(e) => setDe(e.target.value)} aria-label="Início do período" />
                        </FormControl>
                        <FormControl isRequired>
                            <FormLabel fontSize="sm" mb={1}>Até</FormLabel>
                            <Input type="date" size="sm" borderRadius="md" value={ate} onChange={(e) => setAte(e.target.value)} aria-label="Fim do período" />
                        </FormControl>
                    </SimpleGrid>
                    {erro && (
                        <Alert status="error" borderRadius="md" mt={4} fontSize="sm"><AlertIcon />{erro}</Alert>
                    )}
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button variant="ghost" onClick={onClose} isDisabled={baixando}>Cancelar</Button>
                    <Button colorScheme="orange" onClick={baixar} isLoading={baixando} loadingText="Gerando">Baixar planilha</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalExportar;
